import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Controller, FieldError } from 'react-hook-form';
import { debtTypeOptions } from '../../../../../config/globals';
import { DebtFormGroupData } from '../../../../../FormData.dk.types';
import { requiredField } from '../../../../shared-config';

export const TypeField = ({ index }: { index: number }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name={`LoanApplication/Debts.${index}.Type`}
      render={({ field: { name, value }, fieldState: { error } }) => {
        const fieldErrorEmpty = value ? undefined : error;
        const fieldErrorUnspecified: FieldError | undefined =
          value === loan_application.DebtType.Unspecified
            ? {
                type: 'value',
                message: t('Debt.Type.error.missing'),
              }
            : undefined;

        return (
          <RadioFieldUI<DebtFormGroupData>
            name={name}
            label={t('Debt.Type.label')}
            data-testid={`debt-${index}-type`}
            radioStyle="button"
            options={debtTypeOptions}
            registerOptions={requiredField}
            error={fieldErrorEmpty ?? fieldErrorUnspecified}
          />
        );
      }}
    />
  );
};
